import Setting from "../../../Components/Setting/Setting";
export default function SettingPage(props) {
  return <Setting />;
}
